import { Badge, type BoxProps, Image } from "@mantine/core";
import type { JSX } from "react";
import { getBadgeIcon } from "@/sales-tools/challenges/utils/getBadgeIcon";

type ChallengeBadgeProps = BoxProps & {
    badgeType: string | null;
};

export function ChallengeBadge({ badgeType, ...boxProps }: ChallengeBadgeProps): JSX.Element {
    return badgeType ? (
        <Image src={getBadgeIcon(badgeType)} {...boxProps} />
    ) : (
        <Badge color="dark.7" circle {...boxProps} />
    );
}
